import { render, staticRenderFns } from "./SubscriptionSessions.vue?vue&type=template&id=21edda31&"
import script from "./SubscriptionSessions.vue?vue&type=script&lang=js&"
export * from "./SubscriptionSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21edda31')) {
      api.createRecord('21edda31', component.options)
    } else {
      api.reload('21edda31', component.options)
    }
    module.hot.accept("./SubscriptionSessions.vue?vue&type=template&id=21edda31&", function () {
      api.rerender('21edda31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenant_customer/views/Data/SubscriptionSessions.vue"
export default component.exports